import React from 'react';

const ThemeIcon = ({ iconUrl, config, styles }) => {
  return (
    <span className={`w-10 h-10 aspect-square rounded-full ${styles.avatar.background} flex justify-center items-center overflow-hidden flex-shrink-0`}>
      {iconUrl ? (
        <img src={iconUrl} alt="Company Icon" className="w-full h-full object-cover" />
      ) : (
        <i className={`fas fa-${config.icon} text-xl ${styles.avatar.text}`}></i>
      )}
    </span>
  );
};

export default ThemeIcon;
